export const MAX_CSV_ORDERS_COUNT = 8000
